const template = `
<div class="uoe-container">
  <div class="uoe-content">
    <h3 class="uoe-heading"></h3>
      <p>
        We use cookies for different reasons, including measuring your visits to our sites and remembering
        your preferences.
        <span class="consent-necessary-url"></span>
      </p>

      <h4 class="uoe-heading">Analytics data</h4>
      <p>
        We gather analytics data to improve this website. You can choose whether your website usage is
        recorded in our analytics.
        <span class="consent-performance-url"></span>
      </p>
      <div class="uoe-settings">
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="performance"
                 id="uoe-consent-setting-1"
                 value="yes"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-1">I'm OK with analytics data being recorded</label>
        </div>
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="performance"
                 id="uoe-consent-setting-2"
                 value="no"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-2">I do not want my website usage included in analytics data</label>
        </div>
      </div>

      <h4 class="uoe-heading">Personalised ads</h4>
      <p>
        We work with advertising partners to show you personalised ads for events and services you might
        be interested in, such as open days.
        <span class="consent-adverts-url"></span>
      </p>
      <div class="uoe-settings">
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="advertising"
                 id="uoe-consent-setting-3"
                 value="yes"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-3">I'm OK with personalised ads</label>
        </div>
        <div class="uoe-check">
          <input type="radio" class="uoe-check-input" data-consent-choice
                 name="advertising"
                 id="uoe-consent-setting-4"
                 value="no"
          >
          <label class="uoe-check-label" for="uoe-consent-setting-4">I do not want to see personalised ads</label>
        </div>
      </div>

      <p>You can always revisit these settings by clicking on the link at the bottom of all web pages.</p>

      <div class="uoe-actions">
        <button type="button" class="uoe-btn uoe-btn-primary" data-consent-save>Save settings</button>
      </div>
    </div>
  </div>
</div>
`

export default template
